import { render } from "./widgetAction.vue?vue&type=template&id=535da63f"
import script from "./widgetAction.vue?vue&type=script&lang=js"
export * from "./widgetAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__